import React, { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box
} from '@mui/material';
import {
  useNavigate,
  useParams,
  useLocation
} from 'react-router-dom';
import annoFiscaleApi from '../../api/annoFiscaleApi';
import BackButtonDesktop from '../../components/BackButtonDesktop';

export default function CreateAnnoFiscalePage() {

  const { fascicoloId } = useParams();

  const location = useLocation();

  const navigate = useNavigate();

  // 🔥 ORA ARRIVA DA STATE (FONTE CORRETTA)
  const contribuenteId =location.state?.contribuenteId || params.contribuenteId;

  const [anno, setAnno] = useState(new Date().getFullYear());

  const [loading, setLoading] = useState(false);

  const handleSave = async () => {

    try {

      setLoading(true);

      await annoFiscaleApi.create({

        contribuenteId: contribuenteId,

        anno: anno

      });

      navigate(-1);

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);

    }

  };

  return (

    <Container maxWidth="sm">

      <BackButtonDesktop />

      <Typography
        variant="h5"
        sx={{ mb: 2 }}
      >
        Crea Anno Fiscale
      </Typography>

      {!contribuenteId && (
        <Typography color="error" sx={{ mb: 2 }}>
          Errore: contribuenteId mancante
        </Typography>
      )}

      <TextField
        fullWidth
        label="Anno fiscale"
        value={anno}
        onChange={(e) => setAnno(e.target.value)}
        type="number"
        sx={{ mb: 2 }}
      />

      <Button
        variant="contained"
        onClick={handleSave}
        disabled={loading || !contribuenteId}
      >
        Salva
      </Button>

    </Container>

  );

}